var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.7568C7.50797 19.7568 3.20699 16.452 0.367971 13.021C-0.122657 12.428 -0.122657 11.5673 0.367971 10.9743C1.08177 10.1117 2.57762 8.44738 4.57584 6.99287C9.60876 3.32948 14.3814 3.32241 19.4241 6.99287C21.7716 8.70159 23.632 10.9423 23.632 10.9743C24.1226 11.5673 24.1226 12.428 23.632 13.0209C20.7934 16.4515 16.493 19.7568 12 19.7568ZM12 5.71644C7.02376 5.71644 2.71013 10.462 1.50663 11.9165C1.46774 11.9635 1.46774 12.0318 1.50663 12.0788C2.71017 13.5333 7.02376 18.2789 12 18.2789C16.9762 18.2789 21.2898 13.5333 22.4933 12.0788C22.5635 11.994 22.4887 11.9165 22.4933 11.9165C21.2898 10.462 16.9762 5.71644 12 5.71644Z",
    fill: "#B8B8B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.1707C9.14777 17.1707 6.82727 14.8502 6.82727 11.998C6.82727 9.14569 9.14777 6.8252 12 6.8252C14.8523 6.8252 17.1728 9.14569 17.1728 11.998C17.1728 14.8502 14.8523 17.1707 12 17.1707ZM12 8.30313C9.96271 8.30313 8.30521 9.96063 8.30521 11.998C8.30521 14.0353 9.96271 15.6928 12 15.6928C14.0374 15.6928 15.6949 14.0353 15.6949 11.998C15.6949 9.96063 14.0374 8.30313 12 8.30313Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOffIcon);
export default __webpack_public_path__ + "static/media/eye-off-icon.895756e9aa6f0d469c7f08db8448db64.svg";
export { ForwardRef as ReactComponent };